const warn = (s) => {
  console.warn("[react-gtm-module]", s);
};

export default warn;
